var React = require('react');

function Accessible (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"none","d":"M0 0h24v24H0z","key":0}),React.createElement("circle",{"cx":"12","cy":"12","r":"9","key":1}),React.createElement("path",{"d":"M10 16.5l2 -3l2 3m-2 -3v-2l3 -1m-6 0l3 1","key":2}),React.createElement("circle",{"cx":"12","cy":"7.5","r":".5","fill":"currentColor","key":3})]);
}

Accessible.defaultProps = {"className":"icon icon-tabler icon-tabler-accessible","width":"24","height":"24","viewBox":"0 0 24 24","strokeWidth":"1.25","stroke":"currentColor","fill":"none","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Accessible;

Accessible.default = Accessible;
